export const theme = {
	dark: {
		background: '#808085',
		title: '#CCD6F6',
		para: '#8993b1',
		heading: '#CCD6F6',
		line: '#24243a',
		imgBackground: '#0C141B',
		highlightBackground: '#0f1622',
		sideIcons: '#8892b0',
		menuBackground: '#093047',
		card: '#112240',
		linkHover: 'linear-gradient(120deg, #182744, #132c26',
	},
	light: {
		background: '#FFFFFF',
		title: '#233742',
		para: '#233742',
		heading: '#233742',
		line: 'lightgray',
		imgBackground: '#e9f3e8',
		highlightBackground: '#f0f8ef',
		sideIcons: '#766161',
		menuBackground: '#aaeff8',
		card: '#8BD8CE',
		linkHover: 'linear-gradient(135deg, #ccc0f5, #6fd8c1)',
	},
};
